export function generateNakladaSlapRedirectUrl(
  action: 'ASEBA' | 'manual' | 'credits' | 'edukacije'
) {
  const origin = encodeURIComponent(window.location.origin);
  return `https://www.nakladaslap.com/redirect/?to=${action}&ref=${origin}`;
}
